import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/1tool/leckorter-portal/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/builds/1tool/leckorter-portal/layouts/login.vue").then(m => m.default || m))
}